import helpers from '@elab/core/utils/helpers';
import { selectors as configSelectors } from '@elab/core/store/config';
import { selectors as globalSelectors } from '@elab/core/store/global';

export const getConfig = (state, fieldName, selectors) => {
    const masksConfig = configSelectors.getInputMasksConfig(state);
    const currentCountry = globalSelectors.getCountry(state);
    const countryConfig = {
        ...(masksConfig.common || {}),
        ...(masksConfig[currentCountry] || {}),
    };
    const fieldConfig = countryConfig && countryConfig[fieldName];

    if (!fieldConfig || !Array.isArray(fieldConfig.rules)) {
        return null;
    }

    const fieldValue =
        fieldConfig.dependsOnField &&
        selectors.getDataFieldValue(state, fieldConfig.dependsOnField);

    for (const rule of fieldConfig.rules) {
        const isDefaultRule = rule && !rule.dependsOnFieldValues;
        const isCorrectRule =
            rule &&
            fieldConfig.dependsOnField &&
            Array.isArray(rule.dependsOnFieldValues) &&
            rule.dependsOnFieldValues.includes(fieldValue);

        if (isDefaultRule || isCorrectRule) {
            return rule && rule.config;
        }
    }
};

export const separateDigitsAndLetters = (value, replacer = {}) => {
    const { pattern, replacement } = replacer;

    if (!value || !pattern || !replacement) {
        return value;
    }

    return value.replace(pattern, replacement);
};

export const convertingByCustomSettings = (value, maskConfig) => {
    const _value = maskConfig.replacer
        ? separateDigitsAndLetters(value, maskConfig.replacer)
        : value;

    return _value && maskConfig.maxLength ? _value.substring(0, maskConfig.maxLength) : _value;
};

export const mask = async (value, maskConfig) => {
    if (!maskConfig) {
        return value;
    }
    await helpers.loadAsset('IMask');

    const { IMask } = helpers.getAssets();
    const _value = maskConfig.mask ? IMask.pipe(value, maskConfig) : value;

    return convertingByCustomSettings(_value, maskConfig);
};
